import { VAlert } from 'vuetify/lib/components/VAlert';
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VListItemContent } from 'vuetify/lib/components/VList';
import { VListItemSubtitle } from 'vuetify/lib/components/VList';
import { VListItemTitle } from 'vuetify/lib/components/VList';
import { VRow } from 'vuetify/lib/components/VGrid';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c;
  return _c(VContainer, {
    staticClass: "pa-0",
    attrs: {
      "fluid": ""
    }
  }, [_c(VRow, [_c(VCol, {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.deviceType'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.deviceTypes,
      "filter": _vm.filterItems,
      "auto-select-first": "",
      "item-text": "title",
      "item-value": "id",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.setDeviceTypeId
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function ({
        item
      }) {
        return [_c(VListItemContent, [_c(VListItemTitle, [_vm._v(_vm._s(item.title))]), _c(VListItemSubtitle, [_vm._v("ID: " + _vm._s(item.id))])], 1)];
      }
    }]),
    model: {
      value: _vm.deviceTypeId,
      callback: function ($$v) {
        _vm.deviceTypeId = $$v;
      },
      expression: "deviceTypeId"
    }
  })], 1), _c(VCol, {
    attrs: {
      "cols": "6",
      "md": "6"
    }
  }, [_c(VAutocomplete, {
    attrs: {
      "label": _vm.$i18n_t('NiotaClassic.Devices.form.operationalStatus'),
      "color": _vm.color,
      "outlined": _vm.inpOutlined,
      "filled": _vm.inpFilled,
      "items": _vm.operationalStatus,
      "filter": _vm.filterOpStatusItems,
      "auto-select-first": "",
      "return-object": "",
      "item-text": "text",
      "item-value": "value",
      "clearable": "",
      "hide-details": ""
    },
    on: {
      "change": _vm.setOperationalStatus
    },
    model: {
      value: _vm.operationStatus,
      callback: function ($$v) {
        _vm.operationStatus = $$v;
      },
      expression: "operationStatus"
    }
  })], 1)], 1), _c(VDataTable, {
    attrs: {
      "items": _vm.devices,
      "headers": _vm.tableHeaders,
      "footer-props": _vm.tableFooterProps,
      "item-key": "id"
    },
    scopedSlots: _vm._u([{
      key: "item",
      fn: function (items) {
        return [_c('tr', [_c('td', [_vm._v("\n          " + _vm._s(items.item.name) + "\n          "), _c('br'), items.item.errorMessage ? _c('span', {
          staticClass: "red--text"
        }, [_vm._v(_vm._s(items.item.errorMessage))]) : _vm._e()]), _c('td', [_c('div', {
          staticClass: "euiElement"
        }, [_c('pre', [_vm._v(_vm._s(items.item.eui))])])]), _c('td', [_vm.originator.datasource && _vm.originator.datasource.image ? _c('img', {
          staticClass: "image-style",
          attrs: {
            "src": _vm.niota1ImageUrl(_vm.originator.datasource.image)
          }
        }) : _c('span', [_vm._v(_vm._s(_vm.originator.title))])]), _c('td', {
          staticClass: "text-center"
        }, [_c(VIcon, {
          attrs: {
            "color": _vm.color,
            "title": _vm.$i18n_t('Common.delete'),
            "small": ""
          },
          on: {
            "click": function ($event) {
              return _vm.deleteFromList(items.item);
            }
          }
        }, [_vm._v("\n            fal fa-trash-alt\n          ")])], 1)])];
      }
    }, {
      key: "no-data",
      fn: function () {
        return [_c(VAlert, {
          staticClass: "mb-1",
          attrs: {
            "value": true,
            "color": "transparent",
            "icon": "fal fa-comment-exclamation"
          }
        }, [_vm._v("\n        " + _vm._s(_vm.$i18n_t('Common.SorryNothingToDisplay')) + "\n      ")])];
      },
      proxy: true
    }])
  })], 1);
};
var staticRenderFns = [];
export { render, staticRenderFns };